
<template>
  <div class="prepend">
    <div v-if="$slots.default" class="boxed-content"
         :class="{ 'boxed-content--disabled': disabled, 'boxed-content--dropdown-border-radius': dropdownOpen }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">

withDefaults(defineProps<{
  disabled?: boolean
  dropdownOpen?: boolean
}>(), {
  disabled: false,
  dropdownOpen: false
});

</script>
<style lang="scss" scoped>
.boxed-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  color: var(--pidz-white);
  background: var(--pidz-blue);
  border-radius: 5px 0 0 5px;
  border: 1px solid var(--pidz-black);
  font-family: Lato;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &--disabled{
    background:var(--pidz-grey-dark);
    border-color: var(--pidz-black);
  }

  &--dropdown-border-radius{
    border-radius: 5px 0 0 0;
  }
}
</style>
